<template>
    <div id="login-box"
         class="login-box">
        <div class="login-title">
            HIBOX自动化测试系统
        </div>
        <input v-model="phoneNumber" class="login-input" type="text" placeholder="请输入手机号">
        <input v-model="verifyCode " class="login-input" placeholder="请输入短信验证码">
        <el-button @click="fetchVerificationCode" class="verification-button" type="primary" :disabled="cutDownStatus">
            {{cutDownStatus?(second+"(s)后重发"):"点击获取验证码"}}
        </el-button>

        <el-button class="login-btn" circle @click="login">
            <img src="../assets/next.png" alt="">
        </el-button>
    </div>
</template>

<script>
    import {Message} from 'element-ui';
    import {verificationCode, login} from '../libs/api';
    import {startCountDate} from '../utils/coutDate'

    export default {
        name: "login",
        data() {
            return {
                phoneNumber: "",
                verifyCode: "",
                cutDownStatus: false, //开始倒计时
                second: 60
            }
        },
        methods: {
            fetchVerificationCode() {
                if (this.phoneNumber && /^1[3456789]\d{9}$/.test(this.phoneNumber)) {
                    verificationCode({
                        Username: this.phoneNumber
                    }).then(() => {
                        Message.success("发送成功");
                        this.cutDown();
                    }).catch(() => {
                        Message.error('验证码获取失败')
                    })
                } else {
                    Message.error("请输入有效的手机号")
                }
            },
            login() {
                let message = '';
                (!this.phoneNumber || !(/^1[3456789]\d{9}$/.test(this.phoneNumber))) && (message = '请输入有效的手机号');
                (!this.verifyCode || this.verifyCode.length < 6) && (message = '请输入正确验证码');
                if (message) {
                    Message.error(message);
                    return;
                }
                login({
                    Username: this.phoneNumber,
                    VerifyCode: this.verifyCode
                }).then(res => {
                    let message;
                    switch (res.data.Status * 1) {
                        case 0:
                            var token = res.data.Token || '';
                            localStorage.setItem('token', token);
                            this.$router.replace({path: '/home'})
                            break;
                        case 2:
                            message = '提交表单格式有误';
                            break;
                        case 3:
                            message = '该手机号并没有在后台创建';
                            break;
                        case 4:
                            message = '错误的验证码';
                            break;
                        case 6:
                            message = '服务器内部错误';
                            break;
                        default:
                            message = '未知错误，错误码:' + res.data.Status;
                    }
                    message && Message.error(message)
                }).catch(err => {
                    Message.error(JSON.stringify(err) || "未知错误");
                })

            },
            cutDown() {
                this.cutDownStatus = true;
                startCountDate({
                    endDate: [Date.now() + 60000],
                    cutFun: res => {
                        this.second = res[0].second;
                    },
                    finished: () => {
                        this.cutDownStatus = false;
                    }
                })
            }
        }
    }
</script>


<style scoped>
    .login-box {
        flex-direction: column;
        align-items: center;
        justify-content: center;
        display: flex;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.8);
    }

    .login-title {
        margin-top: 20px;
        margin-bottom: 20px;
        font-size: 24px;
        font-weight: bold;
        color: #333;
    }

    .login-input {
        margin-top: 20px;
        border-radius: 3px;
        padding: 10px;
        font-size: 16px;
        background-color: rgba(255, 255, 255, 0.5);
        outline: medium;
        border: 1px solid #eee;
        width: 70%;
    }

    .login-button {
        margin-top: 60px;
        border: none;
        border-radius: 3px;
        padding-top: 5px;
        padding-bottom: 5px;
        font-size: 70px;
        color: #3F90F7;
    }

    /* 禁止 Chrome 自动填充修改 input 样式 */
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        -webkit-transition-delay: 99999s;
        -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
    }

    .verification-button {
        margin-top: 20px;
        width: 70%;
    }

    .login-btn {
        margin-top: 50px;
        width: 120px;
        height: 120px;
        padding: 0;
    }

    .login-btn img {
        width: 120px;
        height: 120px;
    }
</style>
